export class UserInfoModel{
  username: string = 'xxx xxx xxx';
  firstName: string = 'xxx xxx';
  lastName: string = 'xxx xxx';
  badgeCount: Number = 0;
}
